import SweetAlert from 'react-bootstrap-sweetalert';
import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import CountUp from 'react-countup';
import ViewMap from './ViewMap';
import DrawMap from '../common/drawmap';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { fetchGridLayout, getDecoder, getHyphenDDMMMYYYYHHMM, saveGridLayout,sortingDatesInGrid } from '../common/utils';
import redirectURL from "../redirectURL";
import moment from "moment";
import ForceClose from './forceClose.jsx';
import DatePicker from 'react-datepicker'
import { Modal } from 'react-bootstrap';
import CommentModal from './commentModal.js';
import ModelForceClose from './modelForceClose.js';
import Info from '../../assets/icons/info.png'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import BulkForceClose from '../mainpage/bulkForceClose.js';
import ForceClosureModal from './forceClosureModel.js';

const ForceClosure = () => {

    const user = useMemo(() => getDecoder(), []);
    // const [startDate, setStartDate] = useState(moment().subtract(10, "days").toDate());
    const [startDate, setStartDate] = useState(moment().subtract(30,'days').toDate());
    const [endDate, setEndDate] = useState(new Date());
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [allData, setAllData] = useState([])
    const [rowData, setRowData] = useState([])
    const [tranistDelay, setTranistDelay] = useState([])
    const [tranistDelay2, setTranistDelay2] = useState([])
    const [newTranistDelay2, setNewTranistDelay2] = useState([])
    const [newTranistDelay5, setNewTranistDelay5] = useState([])
    const [tranistDelay5, setTranistDelay5] = useState([])
    const [consentApproved, setConsentApproved] = useState([])
    const [newConsentApproved, setNewConsentApproved] = useState([])
    const [consentPending, setConsentPending] = useState([])
    const [newFoConsentPending, setNewFoConsentPending] = useState([])
    const [invalidMobileNo, setInvalidMobileNo] = useState([])
    const [newFoInvalidMobileNo, setNewFoInvalidMobileNo] = useState([])
    const [overly, setOverlay] = useState("show-n")
    const [loadshow, setLoadShow] = useState("show-n")
    const [commentModal, setCommentModal] = useState(false);
    const [forcecloseModal, setForcecloseModal] = useState(false);
    const [rownode, setRownode] = useState([]);
    const [header, setHeader] = useState('Total FO Deliveries');
    const [originOptions, setOriginOptions] = useState([]);
    const forceClosureReason = useRef({
        reasonMap: [],
        mainReason: new Map(),
    })
    const [origin, setOrigin] = useState([{ label: "ALL", value: "ALL" }]); // Initialize state
    const [detailCellRendererParams, setdetailCellRendererParams] = useState(null);
    const [tabOptions, setTabOptions] = useState({ value: 'delayed_trips' });
    const [completedData, setCompletedData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([])
    const [openMap, setOpenMap] = useState({
        sliderRouteTranslate: "",
        showDiv: 'show-n',
        mapinfo: [],
        dealer: "",
        consignment_code: "",
        maptruckno: "",
        geofence_coordinates: [],
        parking_coordinates: [],
        routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
        loadshow: 'show-n',
        sidebarSubHeader: "",
        overly: 'show-m',
        rownode: {},
        leg_no: 0,
        tolls: []
    })
    const gridColumnState = useRef(null)
    const columnApi = useRef(null)
    const defaultColDef = useMemo(() => {
        return {
            sortable: true,
            filter: true,
            autoSizeColumns: true,
            resizable: true,
            pivot: true,
        }
    }, []);
    const statusText = useMemo(() => {
        return ["Consignment Created", "Inside Plant", "In Transit", "Near Customer", "Reached Customer", "Left Customer", "Force Closed", "Proximity Trip Closure", "Cancelled", "Trip Closed"]
    })
    const columnDefs2 = useMemo(() => {
        return [
            {
                headerName: "",
                field: "",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRendererSelector: function (param) {
                    try {
                        if (![null, undefined].includes(param.data._id)) {
                            return {
                                component: ViewMap,
                                params: {
                                    onClickShowRoute: onClickShowRouteLegs
                                }
                            }
                        }
                    } catch (err) {
                        console.log(err);
                        return err
                    }
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "comment_logs",
                pinned: "left",
                filter: false,
                suppressMenu: true,
                width: 50,
                cellRenderer: (param) => {
                    return (
                        ([undefined, 0, null, ''].includes(param.data.comment_logs)) ?
                            < i className="fa fa-comments f20" title='Comment' style={{ color: "#cccc" }}></i > :
                            < i className="fa fa-comments txt-info f20" title='Comment' ></i >
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "tansit_delay_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="icofont icofont-clock-time f20" title='Transit Delay' style={{ color: (param?.data?.transit_delay != undefined && param?.data?.transit_delay == 1) ? "#FF5370" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "deviation_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="fa fa-random f20" title='Deviated Routes' style={{ color: (param?.data?.deviation_identified != undefined && param?.data?.deviation_identified == 1) ? "#9f08b2" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "FO Number",
                field: "fo_number",
                width: 130,
            },
            {
                headerName: "Created Date",
                field: "created_date",
                valueGetter: function (params) {
                    return ![undefined, ''].includes(params.data.created_date) ? getHyphenDDMMMYYYYHHMM(params.data.created_date) : ''
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "New FO Number",
                field: "new_fo_number",
                width: 180,
            },
            {
                headerName: "New FO Created Date",
                field: "new_fo_created_time",
                width: 220,
                valueGetter: function (params) {
                    if (![undefined, '', null].includes(params.data.new_fo_created_time)) {
                        return getHyphenDDMMMYYYYHHMM(params.data.new_fo_created_time)
                    }
                }
            },
            {
                headerName: "Time Diffrence in Creation",
                field: "",
                width: 220,
                valueGetter: (params) => {
                    const start = new Date(params.data.created_date);
                    const end = new Date(params.data.new_fo_created_time);
                    const diffMs = end - start;
                    // const diffMs = end - start;

                    if (isNaN(diffMs)) return '';

                    const totalSeconds = Math.floor(diffMs / 1000);
                    const days = Math.floor(totalSeconds / (3600 * 24));
                    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
                    const minutes = Math.floor((totalSeconds % 3600) / 60);
                    // const seconds = totalSeconds % 60;

                    // Optional: format with leading zeros if needed
                    const pad = (num) => num.toString().padStart(2, '0');

                    return `${days}Days ${pad(hours)}Hours ${pad(minutes)}mins`;
                },
            },
            {
                headerName: "Vehicle No.",
                field: "truck_no",
                width: 122,
            },
            {
                headerName: "Customer Code",
                field: "consignee_code"
            },
            {
                headerName: "Status",
                field: "status",
                width: 148,
                valueGetter: function (params) {
                    return params.data.status === 1
                        ? ([undefined, null, ""].includes(params?.data?.gate_in_time) ? "Consignment Created" : "Inside Plant")
                        : statusText[params.data.status];

                }
            },
            {
                headerName: "SIM Consent Status",
                field: "sim_tracking_state",
                width: 188,
                valueGetter: function (params) {
                    try {
                        if (params.data.tracking_mode == "GPS")
                            return "Approved"
                        else {
                            if ([1, 2, 14].includes(params.data.sim_tracking_state)) {
                                return "Not Registered"
                            }
                            if ([9, 3, 18].includes(params.data.sim_tracking_state)) {
                                return "Approved"
                            }
                            if ([4, 7, 12, 15, 16, 17, 19, 20, 21, 23, 24, 25, 26].includes(params.data.sim_tracking_state)) {
                                return "Consent Approved"
                            }
                            if ([5, 6, 11, 22].includes(params.data.sim_tracking_state)) {
                                return "Consent Pending"
                            }
                            if ([8, 10].includes(params.data.sim_tracking_state)) {
                                return "Consent Declined"
                            }
                        }
                    }
                    catch (e) {
                        return e
                    }
                },
            },
            {
                headerName: "Expected ETA (Nestle)",
                field: "expected_eta",
                valueGetter: function (params) {
                    return (![undefined, ''].includes(params.data.expected_eta)) ?
                        getHyphenDDMMMYYYYHHMM(params.data.expected_eta) : ''
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Revised ETA (Enmovil)",
                field: "revised_trip_end",
                valueGetter: function (params) {
                    return ([undefined, ''].includes(params.data.revised_trip_end)) ?
                        getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) : ''
                },
                cellStyle: function (params) {
                    try {
                        let hourDifference = 0;
                        if (params.data.revised_trip_end && params.data.expected_trip_end) {
                            let revisedDateOnlyMoment = moment(params.data.revised_trip_end);
                            let expectedDateOnlyMoment = moment(params.data.expected_trip_end);
                            hourDifference = revisedDateOnlyMoment.diff(expectedDateOnlyMoment, 'hours');
                        }
                        if (hourDifference >= 1) {
                            return { backgroundColor: "#ff90a3" };
                        }
                        if (hourDifference <= -1) {
                            return { backgroundColor: "#00dea7" };
                        }
                        else {
                            return ''
                        }
                    } catch (error) {
                        return error
                    }
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Tracking Mode",
                field: "tracking_mode"
            },
            {
                headerName: "Invoice Date",
                field: "invoice_time",
                width: 128,
                valueGetter: function (params) {
                    return ![undefined, ''].includes(params.data.invoice_time) ? getHyphenDDMMMYYYYHHMM(params.data.invoice_time) : ''
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Driver Name",
                field: "driver_name",
                width: 128,
            },
            {
                headerName: "Driver Phone No.",
                field: "driver_mobile_no",
                width: 128,
                cellStyle: function (params) {
                    return [undefined, 'Invalid Mobile No.'].includes(params.data.driver_mobile_no) ? { backgroundColor: "#ff90a3" } : ''
                }

            },
            {
                headerName: "Customer Name",
                field: "consignee_name"
            },
            {
                headerName: "Customer Address",
                field: "consignee_address"
            },
            {
                headerName: "Customer City",
                field: "consignee_city"
            },
            {
                headerName: "Customer State",
                field: "consignee_state"
            },
            {
                headerName: "Customer Zone",
                field: "consignee_zone",
            },
            {
                headerName: "Vehicle Type",
                field: "truck_type",
                width: 128,
            },
            {
                headerName: "Plant Code",
                field: "consigner_code",
                width: 120
            },
            {
                headerName: "Plant Name",
                field: "consigner_name",
                width: 130,
                valueGetter: function (params) {
                    return ![undefined, ''].includes(params.data.consigner_name) ? params.data.consigner_name : ''

                }
            },
            {
                headerName: "Plant Zone",
                field: "consigner_zone"
            },
            {
                headerName: "Geofence Gate In",
                field: "gate_in_time",
                width: 130,
                valueGetter: function (params) {
                    return ![undefined, ''].includes(params.data.gate_in_time) ? getHyphenDDMMMYYYYHHMM(params.data.gate_in_time) : ''
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Geofence Gate Out",
                field: "gate_out_time",
                width: 144,
                valueGetter: function (params) {
                    return ![undefined, ''].includes(params.data.gate_out_time) ? getHyphenDDMMMYYYYHHMM(params.data.gate_out_time) : ''
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Mobile Gate In",
                field: "manual_gate_in",
                valueGetter: function (params) {
                    return ![undefined, null, ''].includes(params.data?.manual_gate_in) ? getHyphenDDMMMYYYYHHMM(params.data?.manual_gate_in) : ''
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                width: 144
            },
            {
                headerName: "Mobile Gate Out",
                field: "manual_gate_out",
                valueGetter: function (params) {
                    return ![null, undefined, ''].includes(params.data?.manual_gate_out) ? getHyphenDDMMMYYYYHHMM(params.data?.manual_gate_out) : ''
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                width: 144
            },
            {
                headerName: "Transporter Code",
                field: "transporter_code",
                width: 158,
            },
            {
                headerName: "Transporter Name",
                field: "transporter_name"
            },
            {
                headerName: "Last Packet Time",
                field: "last_packet_time",
                valueGetter: function (params) {
                    return ![undefined, ''].includes(params.data.last_packet_time) ? getHyphenDDMMMYYYYHHMM(params.data.last_packet_time) : ''
                }
            },
            {
                headerName: "Customer Distance from Plant",
                field: "dealer_distance_from_plant"
            },
            {
                headerName: "Comment",
                field: "comment_model",
                filter: false,
                width: 107,
                cellRenderer: (param) => {
                    return (
                        <button class="btn btn-warning custom-btn f12 label label-success">Comment</button>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "Force Close",
                field: "force_close",
                cellRendererSelector: function (param) {
                    try {
                        return ![null, undefined].includes(param.data._id) ? {
                            component: ForceClosureModal,
                            params: {
                                forceClosureReason: forceClosureReason.current,
                                user: user,
                                loadData: loadData,
                                setShow: setShow,
                                setTitle: setTitle,
                                setType: setType
                            }
                        } : ''; // return undefined if you don't want a renderer
                    } catch (err) {
                        console.error(err);
                        return undefined;
                    }
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "Packet Count",
                field: "packet_count",
                width: 144,
                hide: true
            },
            {
                headerName: "Gate In Flag",
                field: "gate_in_flag",
                width: 144,
                hide: true
            },
            {
                headerName: "Gate Out Flag",
                field: "gate_out_flag",
                width: 144,
                hide: true
            },
        ]
    }, []);
    const columnDefs3 = useMemo(() => {
        return [
            {
                headerName: "",
                field: "",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRendererSelector: function (param) {
                    try {
                        return ![null, undefined].includes(param.data._id) ?
                            {
                                component: ViewMap,
                                params: {
                                    onClickShowRoute: onClickShowRouteLegs
                                }
                            } : ''
                    }
                    catch (err) {
                        return err
                    }
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "comment_logs",
                pinned: "left",
                filter: false,
                suppressMenu: true,
                width: 50,
                cellRenderer: (param) => {
                    return [undefined, 0, null, ''].includes(param.data.comment_logs) ? < i className="fa fa-comments f20" title='Comment' style={{ color: "#cccc" }}></i > : < i className="fa fa-comments txt-info f20" title='Comment' ></i >
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "tansit_delay_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="icofont icofont-clock-time f20" title='Transit Delay' style={{ color: (param?.data?.transit_delay != undefined && param?.data?.transit_delay == 1) ? "#FF5370" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "deviation_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="fa fa-random f20" title='Deviated Routes' style={{ color: (param?.data?.deviation_identified != undefined && param?.data?.deviation_identified == 1) ? "#9f08b2" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "FO Number",
                field: "fo_number",
                width: 118,
            },
            {
                headerName: "Vehicle No.",
                field: "truck_no",
                width: 122,
            },
            {
                headerName: "Customer Code",
                field: "consignee_code"
            },
            {
                headerName: "Status",
                field: "status",
                width: 148,
                valueGetter: function (params) {
                    return params.data.status == 1 ?
                        [undefined, null, ''].includes(params.data.gate_in_time) ? "Consignment Created" : "Inside Plant"
                        : statusText[params.data.status]
                }
            },
            {
                headerName: "SIM Consent Status",
                field: "sim_tracking_state",
                width: 188,
                valueGetter: function (params) {
                    try {
                        if (params.data.tracking_mode == "GPS")
                            return "Approved"
                        else {
                            if ([1, 2, 14].includes(params.data.sim_tracking_state)) {
                                return "Not Registered"
                            }
                            if ([9, 3, 18].includes(params.data.sim_tracking_state)) {
                                return "Approved"
                            }
                            if ([4, 7, 12, 15, 16, 17, 19, 20, 21, 23, 24, 25, 26].includes(params.data.sim_tracking_state)) {
                                return "Consent Approved"
                            }
                            if ([5, 6, 11, 22].includes(params.data.sim_tracking_state)) {
                                return "Consent Pending"
                            }
                            if ([8, 10].includes(params.data.sim_tracking_state)) {
                                return "Consent Declined"
                            }
                        }
                    }
                    catch (e) {
                        return e
                    }
                },
            },
            {
                headerName: "Expected ETA (Nestlé)",
                field: "expected_eta",
                valueGetter: function (params) {
                    return ![undefined, ''].includes(params.data.expected_eta) ? getHyphenDDMMMYYYYHHMM(params.data.expected_eta) : ''
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Revised ETA (Enmovil)",
                field: "revised_trip_end",
                valueGetter: function (params) {
                    return ![undefined, ''].includes(params.data.revised_trip_end) ? getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) : ''
                },
                cellStyle: function (params) {
                    try {
                        let hourDifference = 0;
                        if (params.data.revised_trip_end && params.data.expected_trip_end) {
                            let revisedDateOnlyMoment = moment(params.data.revised_trip_end);
                            let expectedDateOnlyMoment = moment(params.data.expected_trip_end);
                            hourDifference = revisedDateOnlyMoment.diff(expectedDateOnlyMoment, 'hours');
                        }
                        if (hourDifference >= 1) {
                            return { backgroundColor: "#ff90a3" };
                        }
                        if (hourDifference <= -1) {
                            return { backgroundColor: "#00dea7" };
                        }
                        else {
                            return ''
                        }
                    } catch (error) {
                        return error
                    }
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Tracking Mode",
                field: "tracking_mode"
            },
            {
                headerName: "Invoice Date",
                field: "invoice_time",
                width: 128,
                valueGetter: function (params) {
                    return ![undefined, ''].includes(params.data.invoice_time) ? getHyphenDDMMMYYYYHHMM(params.data.invoice_time) : ''
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Created Date",
                field: "created_date",
                valueGetter: function (params) {
                    return ![undefined, ''].includes(params.data.created_date) ? getHyphenDDMMMYYYYHHMM(params.data.created_date) : ''
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Driver Name",
                field: "driver_name",
                width: 128,
            },
            {
                headerName: "Driver Phone No.",
                field: "driver_mobile_no",
                width: 128,
                cellStyle: function (params) {
                    return [undefined, 'Invalid Mobile No.'].includes(params.data.driver_mobile_no) ? { backgroundColor: "#ff90a3" } : ''
                }
            },
            {
                headerName: "Customer Name",
                field: "consignee_name"
            },
            {
                headerName: "Customer Address",
                field: "consignee_address"
            },
            {
                headerName: "Customer City",
                field: "consignee_city"
            },
            {
                headerName: "Customer State",
                field: "consignee_state"
            },
            {
                headerName: "Customer Zone",
                field: "consignee_zone",
            },
            {
                headerName: "Vehicle Type",
                field: "truck_type",
                width: 128,
            },
            {
                headerName: "Plant Code",
                field: "consigner_code",
                width: 120
            },
            {
                headerName: "Plant Name",
                field: "consigner_name",
                width: 130,
                valueGetter: function (params) {
                    return ![undefined, '', null].includes(params.data.consigner_name) ? params.data.consigner_name : ' '
                }
            },
            {
                headerName: "Plant Zone",
                field: "consigner_zone"
            },
            {
                headerName: "Gate In Time",
                field: "gate_in_time",
                width: 130,
                valueGetter: function (params) {
                    return ![undefined, ''].includes(params.data.gate_in_time) ? getHyphenDDMMMYYYYHHMM(params.data.gate_in_time) : ''
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Gate Out Time",
                field: "gate_out_time",
                width: 144,
                valueGetter: function (params) {
                    return ![undefined, '', null].includes(params.data.gate_out_time) ? getHyphenDDMMMYYYYHHMM(params.data.gate_out_time) : ''
                },
                comparator: (date1, date2) => {
                    if (!!date1 && !!date2) {
                        let d1 = moment(date1, 'DD/MM/YYYY HH:mm')
                        let d2 = moment(date2, 'DD/MM/YYYY HH:mm')
                        return d2.isBefore(d1) ? 1 : -1
                    }
                },
            },
            {
                headerName: "Mobile Gate In",
                field: "manual_gate_in",
                valueGetter: function (params) {
                    return ![undefined, '', null].includes(params.data?.manual_gate_in) ? getHyphenDDMMMYYYYHHMM(params.data?.manual_gate_in) : ''
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                width: 144
            },
            {
                headerName: "Mobile Gate Out",
                field: "manual_gate_out",
                valueGetter: function (params) {
                    return ![undefined, null, ''].includes(params.data?.manual_gate_out) ? getHyphenDDMMMYYYYHHMM(params.data?.manual_gate_out) : ''
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                width: 144
            },
            {
                headerName: "Transporter Code",
                field: "transporter_code",
                width: 158,
            },
            {
                headerName: "Transporter Name",
                field: "transporter_name"
            },
            {
                headerName: "Last Packet Time",
                field: "last_packet_time",
                valueGetter: function (params) {
                    return ![undefined, null, ''].includes(params.data.last_packet_time) ? getHyphenDDMMMYYYYHHMM(params.data.last_packet_time) : ''
                }
            },
            {
                headerName: "Customer Distance from Plant",
                field: "dealer_distance_from_plant"
            },
            {
                headerName: "Comment",
                field: "comment_model",
                filter: false,
                width: 107,
                cellRenderer: (param) => {
                    return (
                        <button class="btn btn-warning custom-btn f12 label label-success">Comment</button>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "Force Close",
                field: "force_close",
                cellRendererSelector: function (param) {
                    try {
                        return ![null, undefined].includes(param.data._id) ?
                            {
                                component: ForceClosureModal,
                                params: {
                                    forceClosureReason: forceClosureReason.current,
                                    user: user,
                                    loadData: loadData,
                                    setShow: setShow,
                                    setTitle: setTitle,
                                    setType: setType
                                }
                            } : ''
                    } catch (err) {
                        return err;
                    }
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "Packet Count",
                field: "packet_count",
                width: 144,
                hide: true
            },
            {
                headerName: "Gate In Flag",
                field: "gate_in_flag",
                width: 144,
                hide: true
            },
            {
                headerName: "Gate Out Flag",
                field: "gate_out_flag",
                width: 144,
                hide: true
            },
        ]
    }, []);

    useEffect(() => {
        let params = {}
        if (user.role[0] == "DEALER")
            params["user_code"] = user.dealer_code ?? "EMPTY"
        else if (user.role[0] == "PLANT") {
            params["plant_codes"] = user.plant_codes ?? "EMPTY"
        }
        redirectURL.get("consignments/getConsigner",  { params })
            .then(response2 => {
                let plantOPtions = [{ "label": "ALL", "value": "ALL" }, ...response2.data.records]
                setOriginOptions(plantOPtions)
            })
            .catch(err => {
                return err;
            })
        redirectURL.get("consignments/getForceClosureReasons", {})
            .then(response2 => {
                const reasonMap = new Map()
                const mainReason = []
                response2?.data?.data.forEach(each => {
                    mainReason.push({ label: Object.keys(each)[1], value: Object.keys(each)[1] })
                    reasonMap.set(Object.keys(each)[1], each[Object.keys(each)[1]].map(e => ({ label: e, value: e })))
                })
                mainReason.push({ label: "Other", value: "Other" })
                forceClosureReason.current = {
                    reasonMap,
                    mainReason
                }
            })
            .catch(err => {
                return err;
            })

        if (tabOptions.value === "delayed_trips") {
            setColumnDefs(columnDefs3)
        }
        else{
            setColumnDefs(columnDefs2)
        }
        loadData();

    }, [tabOptions.value]);

    const submitHandler = (e) => {
        loadData()
    }


    const loadData = async () => {
        let params = {}
        if (!!startDate && !!endDate) {
            params["sdate"] = moment.parseZone(startDate).utcOffset("+05:30").format("YYYY-MM-DD");
            params["edate"] = moment.parseZone(endDate).utcOffset("+05:30").format("YYYY-MM-DD");
        }
        setOverlay("show-m")
        setLoadShow("show-m")
        if (user.role[0] == "DEALER")
            params["user_code"] = user.dealer_code ?? "EMPTY"
        else if (user.role[0] == "PLANT") {
            params["plant_codes"] = user.plant_codes ?? "EMPTY"
        }
        if (origin.length > 0 && origin[0].value != "ALL")
            params["consigner_code"] = origin.map(e => e.value)
        await redirectURL.post("consignments/currentTimePastETA", params)
            .then(resp => {
                if (resp.data.status == "success") {
                    let data = JSON.parse(resp.data.apiData)
                    let all_data = parseJSONSafely(data, "all_data")
                    let transit_delay = new Set(parseJSONSafely(data, "transit_delay"))
                    let consent_approved = new Set(parseJSONSafely(data, "consent_approved"))
                    let consent_pending = new Set(parseJSONSafely(data, "consent_pending"))
                    let invalid_driver_nos = new Set(parseJSONSafely(data, "invalid_driver_nos"))
                    let newlyCreated = all_data.filter((item) => item.new_fo_created_for_truck == 1)
                    setRowData(all_data);
                    if (tabOptions.value === "delayed_trips") {
                        setRowData(all_data);
                        setAllData(all_data);
                        setTranistDelay(all_data.filter((item) => transit_delay.has(item._id)))
                        const now = moment(); // Current date
                        setTranistDelay2(all_data.filter((item) => {
                            const eta = moment(item.expected_eta)
                            const differenceInDays = now.diff(eta, "minutes")
                            if (differenceInDays > 2880 && differenceInDays < 7200)  // 2880 in 2 hours and 7200 is 5 hours
                                return true
                            else
                                return false
                        }))
                        setTranistDelay5(all_data.filter((item) => {
                            const eta = moment(item.expected_eta)
                            const differenceInDays = now.diff(eta, "minutes")
                            if (differenceInDays >= 7200)
                                return true
                            else
                                return false
                        }))
                        setConsentApproved(all_data.filter((item) => consent_approved.has(item._id)))
                        setConsentPending(all_data.filter((item) => consent_pending.has(item._id)))
                        setInvalidMobileNo(all_data.filter((item) => invalid_driver_nos.has(item._id)))
                    } else {
                        setCompletedData(newlyCreated)
                        setRowData(newlyCreated)
                        setCompletedData(newlyCreated)
                        const now = moment(); // Current date
                        setNewTranistDelay2(newlyCreated.filter((item) => {
                            const eta = moment(item.expected_eta)
                            const differenceInDays = now.diff(eta, "minutes")
                            if (differenceInDays > 2880 && differenceInDays < 7200)
                                return true
                            else
                                return false
                        }))
                        setNewTranistDelay5(newlyCreated.filter((item) => {
                            const eta = moment(item.expected_eta)
                            const differenceInDays = now.diff(eta, "minutes")
                            if (differenceInDays >= 7200)
                                return true
                            else
                                return false
                        }))
                        setNewConsentApproved(newlyCreated.filter((item) => consent_approved.has(item._id)))
                        setNewFoConsentPending(newlyCreated.filter((item) => consent_pending.has(item._id)))
                        setNewFoInvalidMobileNo(newlyCreated.filter((item) => invalid_driver_nos.has(item._id)))
                    }


                    setOverlay("show-n")
                    setLoadShow("show-n")
                }
            })
            .catch(err => {
                console.log(err)
                setOverlay("show-n")
                setLoadShow("show-n")
                return ''
            })
    }

    const saveGrid = async (e) => {
        const coloumnState = columnApi.current.api.getColumnState()
        let temp = await saveGridLayout(user.email, tabOptions.value, coloumnState)
        gridColumnState.current = coloumnState
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully updated")
            setType("success")
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }

    const resetGrid = async (e) => {
        let coloumnState = columnDefs
        let temp = await saveGridLayout(user.email, tabOptions.value, coloumnState)
        gridColumnState.current = coloumnState
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully reset")
            setType("success")
            columnApi.current.api.resetColumnState()
        }
        else {
            setShow(true)
            setTitle("Failed to reset grid")
            setType("danger")
        }
    }

    const changeOriginHandler = (selected) => {
        if (selected.find(e => e.value === "ALL"))
            setOrigin([{ label: "ALL", value: "ALL" }])
        else
            setOrigin(selected)
    }

    const closeForceCloseModal = (e) => {
        setForcecloseModal(false)
        setRownode([])
    }

    const handleStartDateChange = (date) => {
        if (endDate && date > endDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setStartDate(date)
        }
    };

    const handleEndDateChange = (date) => {
        if (startDate && date < startDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setEndDate(date)
        }
    };

    const onShowForceCloseModal = (e) => {
        setForcecloseModal(true)
        setRownode(e)
    }

    const closeMapModal = () => {
        setOverlay("show-n")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
    }

    const onClickHideAll = () => {
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setOverlay("show-n")
        setLoadShow("show-n")
    }

    const onClickShowRouteLegs = (rownode) => {
        setOverlay("show-m")
        setLoadShow("show-m")
        let e = rownode.data
        const getFormattedDate = (value) =>
            !!value ? moment.parseZone(value).format('YYYY-MM-DD HH:mm:ss') : null;
        const gateouttime =
            getFormattedDate(e.manual_gate_in) ||
            getFormattedDate(e.gate_in_time) ||
            getFormattedDate(e.created_date) ||
            '';
        let edate = '';
        let end_date;
        if (e.status <= 2) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = end_date
        }
        else if ((e.status == 3 || e.status == 4)) {
            if (e.recent_dealer_reported) {
                end_date = e.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = edate = moment.parseZone(e.recent_dealer_reported).format('YYYY-MM-DD HH:mm:ss')
            }
        }
        else if (e.status == 5) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = moment.parseZone(e.tvp_gate_in).format('YYYY-MM-DD HH:mm:ss')
            }
            else if (e.left_dealer_marked) {
                end_date = moment.parseZone(e.left_dealer_marked).format('YYYY-MM-DD HH:mm:ss')
                edate = moment.parseZone(e.left_dealer_marked).format('YYYY-MM-DD HH:mm:ss')
            }
        }
        else if (e.status == 6) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            } else if (e.force_closure_time) {
                end_date = moment.parseZone(e.force_closure_time).format('YYYY-MM-DD HH:mm:ss')
            }
        }
        else if (e.status == 9) {
            end_date = moment.parseZone(e.trip_closure_time).format('YYYY-MM-DD HH:mm:ss')
        }
        else {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = moment.parseZone(end_date).format('YYYY-MM-DD HH:mm:ss')
        }
        if (!end_date) {
            // When end date is unavailable then current date is considered as end date.
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        var reqData = {
            truck_no: e.truck_no,
            gate_out_time: gateouttime,
            seconddate: end_date,
            screen: "consignment",
            display_elis_base_route: 1,
            user_email: user.email
        }
        if (e.consignee_code !== undefined) reqData.consignee_code = e.consignee_code
        if (e.consignment_code !== undefined) reqData.consignment_code = e.consignment_code
        redirectURL.post('/consignments/maproutes', reqData, {
            headers: {
                'content-type': 'application/json'
            }
        })
            .then((response) => {
                var records = response.data;
                if (response?.data?.status == "failure") {
                    setShow(true)
                    setTitle((e.last_packet_time != undefined && e.last_packet_time != "") ? "Map becomes accessible once the vehicle has been gated in" : "No GPS data available")
                    setType("danger")
                    setOverlay("show-n")
                    setLoadShow("show-n")
                    return
                }
                else if (!(response?.data !== null && typeof response?.data === 'object')) {
                    setShow(true)
                    setTitle((e.last_packet_time != undefined && e.last_packet_time != "") ? "Map becomes accessible once the vehicle has been gated in" : "No GPS data available")
                    setType("danger")
                    setOverlay("show-n")
                    setLoadShow("show-n")
                }
                try {
                    if (records.coords.length == 0) {
                        setShow(true)
                        setTitle((e.last_packet_time != undefined && e.last_packet_time != "") ? "Map becomes accessible once the vehicle has been gated in" : "No GPS data available ")
                        setType("danger")
                        setOverlay("show-n")
                        setLoadShow("show-n")
                    }
                    else {
                        if (records != '') {
                            var sdate = e.gate_out_time;
                            if (e.invoice_time) {
                                sdate = e.invoice_time;
                            }
                            else {
                                if (e.gate_in_time) {
                                    sdate = e.gate_in_time;
                                }
                                else {
                                    if (e.gate_out_time) {
                                        sdate = e.gate_out_time;
                                    }
                                }
                            }
                            if (e.status <= 4) {
                                end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                edate = end_date
                            }
                            else if (e.status == 5) {
                                if (e.left_dealer_marked) {
                                    edate = moment.parseZone(e.left_dealer_marked).format('YYYY-MM-DD HH:mm:ss')
                                }
                                else {
                                    end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                    edate = end_date
                                }
                            }
                            let consignee_city;
                            consignee_city = e.consignee_city
                            var params = {
                                "base_route_id": e.base_route_id,
                                "consigner_code": e.consigner_code,
                                "consignee_city": consignee_city
                            }
                            var baseRouteCoords = eval(records.base_route);
                            setOpenMap({
                                overly: "show-m",
                                sliderRouteTranslate: "slider-translate-60p",
                                mapinfo: records,
                                dealer: e.consignee_code,
                                consignment_code: "FO Number : " + e.fo_number,
                                maptruckno: e.truck_no,
                                routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                loadshow: 'show-n',
                                sidebarSubHeader: "Consignment Information",
                                rownode: e,
                                leg_no: 0,
                                tolls: records.tolls,
                                baseRouteCoords: baseRouteCoords
                            })
                            setLoadShow("show-n")
                            var params =
                            {
                                consignee_code: e.consignee_code,
                                dept_code: e.dept_code
                            }
                            redirectURL.post('/consignments/geofencedata', params).then((response) => {
                                var records1 = response.data.records;
                                let parkingGeodata = []
                                if (response.data.parkingGeofence[0] !== undefined) parkingGeodata = response.data.parkingGeofence[0]
                                var geofence_coords = []
                                if (records1.length) {
                                    geofence_coords = records1[0].geofence_coordinates;
                                }
                                setLoadShow("show-n")
                            })
                        }
                    }
                }
                catch (e) {
                    return e
                }

            })
            .catch(function (error) {
                return error
            });
    }

    const onGridReady = useCallback(async (params) => {
        await fetchGridLayout(user.email, tabOptions.value)
            .then(async res => {
                if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                    gridColumnState.current = res.data.data[0].columnState
                    await params?.api?.applyColumnState({
                        state: res.data.data[0]?.columnState,
                        applyOrder: true,
                    })
                }
            })
            .catch(err => console.log(err))
    }, [tabOptions.value]);


    const CounterClick = (counter) => {
        switch (counter) {
            case "transit_delay2":
                tabOptions.value == 'delayed_trips' ? setRowData(tranistDelay2) : setRowData(newTranistDelay2)
                setHeader("ETA exceeded (> 2)")
                break;
            case "transit_delay5":
                tabOptions.value == 'delayed_trips' ? setRowData(tranistDelay5) : setRowData(newTranistDelay5)
                setHeader("ETA exceeded (> 5)")
                break;
            case "consignments":
                tabOptions.value == 'delayed_trips' ? setRowData(allData) : setRowData(completedData)
                setHeader("Total FO Deliveries")
                break;
            case "consent_approved":
                tabOptions.value == 'delayed_trips' ? setRowData(consentApproved) : setRowData(newConsentApproved)
                setHeader("Consent Approved")
                break;
            case "consent_pending":
                tabOptions.value == 'delayed_trips' ? setRowData(consentPending) : setRowData(newFoConsentPending)
                setHeader("Consent Pending")
                break;
            case "invalid_driver_nos":
                tabOptions.value == 'delayed_trips' ? setRowData(invalidMobileNo) : setRowData(newFoInvalidMobileNo)
                setHeader("Invalid Driver Number")
                break;
            default:
                tabOptions.value == 'delayed_trips' ? setRowData(allData) : setRowData(completedData)
                setHeader("Total FO Deliveries")
                break;
        }
    }

    const onCellClicked = (params) => {
        if (params.colDef.field == "comment_model") {
            setCommentModal(true)
            setRownode(params.data)
        }
        else if (params.colDef.field == "comment_logs") {
            let nogpscols = [
                {
                    headerName: "FO Number",
                    field: "fo_number",
                },
                {
                    headerName: "Vehicle No.",
                    field: "truck_no",
                },
                {
                    headerName: "Customer Code",
                    field: "consignee_code",
                },
                {
                    headerName: "Customer Name",
                    field: "consignee_name",
                },
                {
                    headerName: "Comment",
                    field: "comment",
                },
                {
                    headerName: "Commented By",
                    field: "email",
                },
                {
                    headerName: "Commented Date",
                    field: "created_on",
                    valueGetter: function (params) {
                        if (params.data.created_on != undefined && params.data.created_on != '') {
                            return getHyphenDDMMMYYYYHHMM(params.data.created_on)
                        }
                    },
                },
            ]
            params.node.setExpanded(!params.node.expanded)
            setdetailCellRendererParams({
                detailGridOptions: {
                    columnDefs: nogpscols,
                    defaultColDef: {
                        flex: 1,
                    },
                },
                getDetailRowData: (params) => {
                    redirectURL.post('/consignments/showCommentLegs', {
                        consignment_code: params.data.consignment_code
                    })
                        .then(async (response) => {
                            params.successCallback(response.data.comments ?? []);

                        });
                },
            })
        }
    }
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderRadius: "0px",
            borderColor: state.isFocused ? "#ccc" : provided.borderColor,
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: "white", // Ensures dropdown menu is white
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "#f0f0f0" : "white", // Light gray instead of blue
            color: "black", // Ensures text remains readable
            cursor: "pointer",
        }),
    };
    const handleTabChange = (value) => {
        setTabOptions({ value });
    };


    return (
        <div className="container-fluid">
            <SweetAlert
                show={show}
                type={type}
                title={title}
                onConfirm={() => { setShow(false); setTitle('') }}>
            </SweetAlert>
            {
                commentModal &&
                <CommentModal setShow={setShow} setTitle={setTitle} setType={setType} user={user} commentModal={commentModal}
                    consignment={rownode} setCommentModal={setCommentModal} loadData={loadData} setRownode={setRownode} />
            }
            <Modal
                onHide={closeForceCloseModal}
                dialogClassName="my-modal"
                show={forcecloseModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Force Close</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeForceCloseModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <ModelForceClose rownode={rownode} setShow={setShow} setTitle={setTitle} setType={setType} closeForceCloseModal={closeForceCloseModal} changeReloadPage={loadData} user={user} />
                </Modal.Body>
            </Modal>
            <h5 className="mb-15p fbold f20">
                <i className="icofont icofont-vehicle-delivery-van cus-i"></i><span style={{ fontWeight: "600" }}>Force Closure Summary Report</span>
            </h5>
            <div className="row" style={{ marginBottom: "1%" }}>
                <div className="col-xl-12 col-lg-12">
                    <button
                        onClick={() => { handleTabChange('delayed_trips') }}
                        className={(tabOptions.value == "delayed_trips") ? "btn btn-info f14" : "btn tab-btn f14"}
                        style={{
                            display: (tabOptions.value == "delayed_trips") ? "inline-flex" : ""
                        }}
                    >
                        Delayed Trips
                    </button>
                    <button
                        onClick={() => { handleTabChange('new_trips') }}
                        className={(tabOptions.value == "new_trips") ? "btn btn-info f14" : "btn tab-btn f14"}
                        style={{
                            display: (tabOptions.value == "new_trips") ? "inline-flex" : ""
                        }}
                    >
                        New Trips
                    </button>
                </div>
            </div>
            <div className="row">
                <div className="row col-xl-12 col-lg-12">
                    <div className="col-xl-3 col-lg-3 form-group">
                        <label>Select Plant</label>
                        <Select
                            className="border-radius-0"
                            isMulti={true}
                            id="searchPlant"
                            style={{ borderRadius: "0px" }}
                            value={origin}
                            onChange={changeOriginHandler}
                            options={originOptions}
                            required
                        />
                    </div>
                    <div className="col-xl-3 col-lg-3 form-group">
                        <label>From Date</label>
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChange}
                            name="startDate"
                            className="datepicker-custom"
                            autoComplete='off'
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>
                    <div className="col-xl-3 col-lg-3 form-group">
                        <label>To Date</label>
                        <DatePicker
                            selected={endDate}
                            onChange={handleEndDateChange}
                            className="datepicker-custom"
                            autoComplete="off"
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>
                    <div className="form-group" >
                        <button type="submit" className="btn btn-success"
                            style={{
                                padding: "8px 14px",
                                border: "none",
                                borderRadius: "4px",
                                marginTop: '25px',
                                marginLeft: '65px',
                            }} onClick={submitHandler}
                        >Submit
                        </button>
                    </div>
                </div>
                <div className="col-xl-12 col-lg-12 col-sm-12 beffect">
                    <div className="card" style={{ height: "148px" }}>
                        <div className="card-body row" style={{ padding: "14px", overflow: "hidden" }}>
                            <div className="col-md-2 cpointer addition-col-right" onClick={() => CounterClick("consignments")}>
                                <h4 className="greenfont f35">
                                    <span className="counter">
                                        <CountUp end={tabOptions.value == 'delayed_trips' ? allData.length : completedData.length} />
                                    </span>
                                </h4>
                                <span className="f14">
                                    Total FO Deliveries
                                </span>
                            </div>
                            <div className="col-md-2  cpointer addition-col-right" onClick={() => CounterClick("transit_delay2")}>
                                <h4 className="f35" style={{ color: "#ff5370" }}>
                                    <span className="counter">
                                        <CountUp end={tabOptions.value == 'delayed_trips' ? tranistDelay2.length : newTranistDelay2.length} />
                                    </span>
                                </h4>
                                <span className="f14">
                                    ETA exceeded (&gt; 2)
                                </span>
                            </div>
                            <div className="col-md-2  cpointer addition-col-right" onClick={() => CounterClick("transit_delay5")}>
                                <h4 className="f35" style={{ color: "#c13048" }}>
                                    <span className="counter">
                                        <CountUp end={tabOptions.value == 'delayed_trips' ? tranistDelay5.length : newTranistDelay5.length} />
                                    </span>
                                </h4>
                                <span className="f14">
                                    ETA exceeded (&gt; 5)
                                </span>
                            </div>
                            <div className="col-md-2  cpointer addition-col-right" onClick={() => CounterClick("consent_approved")}>
                                <h4 className="f35" style={{ color: "#17b169" }}>
                                    <span className="counter">
                                        <CountUp end={tabOptions.value == 'delayed_trips' ? consentApproved.length : newConsentApproved.length} />
                                    </span>
                                </h4>
                                <span className="f14">
                                    Consent Approved
                                </span>
                            </div>
                            <div className="col-md-2  cpointer addition-col-right" onClick={() => CounterClick("consent_pending")}>
                                <h4 className="f35" style={{ color: "#a34518" }}>
                                    <span className="counter">
                                        <CountUp end={tabOptions.value == 'delayed_trips' ? consentPending.length : newFoConsentPending.length} />
                                    </span>
                                </h4>
                                <span className="f14">
                                    Consent Pending
                                </span>
                            </div>
                            <div className="col-md-2  cpointer addition-col-right" onClick={() => CounterClick("invalid_driver_nos")}>
                                <h4 className="f35" style={{ color: "#d70040" }}>
                                    <span className="counter">
                                        <CountUp end={tabOptions.value == 'delayed_trips' ? invalidMobileNo.length : newFoInvalidMobileNo} />
                                    </span>
                                </h4>
                                <span className="f14">
                                    Invalid Driver Number
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-12 col-lg-12 col-sm-12">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12">
                            <div className="card">
                                <div className="card-header main-page-display">
                                    <h5>
                                        <i className="icofont icofont-vehicle-delivery-van cus-i"></i> <span>{`${header}`}</span>
                                    </h5>
                                    <div>
                                        <button type="button" title="Reset Grid Layout" name="resetgrid" className="btn btn-info float-right action_btn main-page-gridbutton" onClick={resetGrid}> <i className="fa fa-reply"></i> </button>
                                        <button type="button" title="Save Grid Layout" name="savegrid" className="btn btn-success float-right action_btn main-page-gridbutton" onClick={saveGrid}> <i className="fa fa-save"></i> </button>
                                        <BulkForceClose setOverlay={setOverlay} setType={setType} setTitle={setTitle} setShow={setShow}
                                            loadConsignmentsData={loadData} user={user} />
                                    </div>
                                </div>
                                <div className="card-body pt-10px">
                                    <div className="row"> <div className="col-xl-12 col-lg-12 mb-10p">
                                        <span className="float-right" style={{ fontSize: "15px", fontWeight: "400", lineHeight: "1.5" }}>
                                            <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                                                <i className="icofont icofont-map-pins f20"></i>&nbsp;&nbsp;View Route
                                            </button>
                                            <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                                                < i className="fa fa-comments txt-info f20" title='Comment' style={{ fontSize: "20px" }} ></i>&nbsp;&nbsp;Comment Logs
                                            </button>
                                            <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                                                <i className="icofont icofont-clock-time" style={{ color: "#ff5370", fontSize: "20px" }}></i>&nbsp;&nbsp;Transit Delays
                                            </button>
                                            <button type="button" className="btn btn-default mybtn display-inflex-center-center">
                                                <i className="fa fa-random purple" style={{ fontSize: "20px" }}></i>&nbsp;&nbsp;Deviated Routes
                                            </button>
                                        </span>
                                    </div></div>
                                    {/* <div className="card-body" style={{ padding: "14px", overflow: "hidden" }}> */}
                                    <div className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                        <AgGridReact
                                            key={tabOptions.value}
                                            ref={columnApi}
                                            columnDefs={columnDefs}
                                            rowData={rowData}
                                            defaultColDef={defaultColDef}
                                            pagination={true}
                                            paginationPageSize={50}
                                            onGridReady={onGridReady}
                                            enableRangeSelection={true}
                                            enableCellContextMenu={true}
                                            masterDetail={true}
                                            detailCellRendererParams={detailCellRendererParams}
                                            onCellClicked={onCellClicked}
                                            sideBar={{
                                                toolPanels: [
                                                    {
                                                        id: "columns",
                                                        labelDefault: "Columns",
                                                        labelKey: "columns",
                                                        iconKey: "columns",
                                                        toolPanel: "agColumnsToolPanel",
                                                        toolPanelParams: {
                                                            suppressPivotMode: true,
                                                            suppressRowGroups: true,
                                                            suppressValues: true,
                                                        }
                                                    },
                                                    {
                                                        id: "filters",
                                                        labelDefault: "Filters",
                                                        labelKey: "filters",
                                                        iconKey: "filter",
                                                        toolPanel: "agFiltersToolPanel"
                                                    }
                                                ]
                                            }}
                                            statusBar={{
                                                statusPanels: [
                                                    {
                                                        statusPanel: "agTotalAndFilteredRowCountComponent",
                                                        align: "left"
                                                    },
                                                    {
                                                        statusPanel: "agTotalRowCountComponent",
                                                        align: "center"
                                                    },
                                                    { statusPanel: "agFilteredRowCountComponent" },
                                                    { statusPanel: "agSelectedRowCountComponent" },
                                                    { statusPanel: "agAggregationComponent" }
                                                ]
                                            }}
                                        />
                                    </div>
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div></div>
            {
                openMap.sliderRouteTranslate != '' ?
                    <div className={"slide-r " + (openMap.sliderRouteTranslate)} style={{ overflow: "auto" }}>
                        <div className="slide-r-title">
                            <h4>
                                {(openMap.consignment_code)}
                                <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeMapModal} >X</span>
                            </h4>
                        </div>
                        <div className="slide-r-body" style={{ position: "relative" }}>
                            <div className="row col-xl-12 col-lg-12 ml-0p n-p-0">
                                <DrawMap
                                    rownode={openMap.rownode}
                                    mapFor={"consignment"}
                                    tolls={openMap.tolls}
                                    googleroutes={openMap.googelRoutes}
                                    truckno={openMap.maptruckno}
                                    dealer={openMap.dealer}
                                    mapinfo={openMap.mapinfo}
                                    deptcode={openMap.deptcode}
                                    defTransitCoords={openMap.defTransitCoords}
                                    baseRouteCoords={openMap.baseRouteCoords}
                                    geofence_coordinates={openMap.geofence_coordinates}
                                    parking_coordinates={openMap.parking_coordinates}
                                />
                                <div className="col-xl-12 col-lg-12 n-p-0">
                                    <div className="crm-numbers pb-0">
                                        <h3 className="subH">{openMap.sidebarSubHeader}</h3>
                                        <div className="col-xl-12 col-lg-12 row">
                                            <div className="col route-block">
                                                <label className="sidebar-label">Vehicle No.</label>
                                                <div>{openMap.routeTruck.truck_no}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">Start Time</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.start_time) : "-"}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">End Time</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.end_time) : "-"}</div>
                                            </div>

                                            <div className="col route-block">
                                                <label className="sidebar-label">GPS Distance</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? Math.round(openMap.mapinfo.route_details.distance_without_google / 1000) : "0"} Kms</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""
            }
            <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}
                onClick={onClickHideAll}
            ></div>
            <div className={"dataLoadpage " + (loadshow)}></div>
            <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
        </div>
    )
}
export default ForceClosure


function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

function parseJSONSafely(data, key) {
    try {
        return JSON.parse(data[key]);
    } catch (error) {
        console.error(`Error parsing JSON for key "${key}":`, error);
        return []; // Return a default value, e.g., null or an empty object
    }
}